/* ================================================
   Newgarden — Cancelación con retención / recuperación
   ================================================ */

(function () {
  'use strict';

  const CFG = window.__OC_CFG__ || {};
  const API_URL       = CFG.apiUrl || '';
  const HTML_LANG     = CFG.htmlLang || document.documentElement.lang || 'es';
  const ORDER_PREFIX  = CFG.orderPrefix || '';
  const SHOP_URL      = CFG.shopUrl || '/';
  const TRACKING_URL  = CFG.trackingUrl || '/pages/tracking';
  const CANCEL_DELAY  = CFG.cancelDelayMs || 3000;
  const REASON_MIN    = CFG.reasonMinLength || 20;
  const T             = CFG.t || {};
  const ERRORS        = T.errors || {};

  const formSection  = document.getElementById('oc-form-section');
  const formEl       = document.getElementById('oc-form');
  const inputOrder   = document.getElementById('oc-order-number');
  const inputEmail   = document.getElementById('oc-email');
  const submitBtn    = document.getElementById('oc-submit');
  const skeletonEl   = document.getElementById('oc-skeleton');
  const confirmEl    = document.getElementById('oc-confirm');
  const successEl    = document.getElementById('oc-success');
  const errorEl      = document.getElementById('oc-error');
  const liveRegion   = document.getElementById('oc-live');
  const confirmBtn   = document.getElementById('oc-confirm-cancel');
  const keepBtn      = document.getElementById('oc-keep-order');
  const reasonEl     = document.getElementById('oc-reason');
  const reasonCounterEl = document.getElementById('oc-reason-counter');
  const delayHintEl  = document.getElementById('oc-delay-hint');

  if (!formEl) return;

  let pendingOrder = null;
  let currentItems = [];
  let delayReady   = false;
  let delayTimer   = null;
  let delayInterval = null;

  inputOrder.addEventListener('input', function () {
    const sel = this.selectionStart;
    this.value = this.value.toUpperCase();
    this.setSelectionRange(sel, sel);
  });

  formEl.addEventListener('submit', function (e) {
    e.preventDefault();
    doLookup();
  });

  document.querySelectorAll('.oc-back-btn').forEach(function (b) {
    b.addEventListener('click', showForm);
  });

  if (keepBtn) {
    keepBtn.addEventListener('click', function () {
      window.location.href = TRACKING_URL;
    });
  }

  if (confirmBtn) confirmBtn.addEventListener('click', doCancel);
  if (reasonEl) {
    reasonEl.addEventListener('input', function () {
      updateReasonCounter();
      updateCancelButtonState();
    });
  }

  async function doLookup() {
    const rawOrder = (inputOrder.value || '').trim().toUpperCase();
    const email    = (inputEmail.value  || '').trim().toLowerCase();

    if (!rawOrder || !email) {
      if (!rawOrder) highlightError(inputOrder);
      if (!email)    highlightError(inputEmail);
      announce(ERRORS.INVALID_INPUT || 'Completa todos los campos.');
      return;
    }
    if (!isValidEmail(email)) {
      highlightError(inputEmail);
      return;
    }

    pendingOrder = { orderName: normalizeOrderName(rawOrder), email };
    showSkeleton();
    setSubmitLoading(true);

    try {
      const data = await apiCall('lookup', pendingOrder.orderName, pendingOrder.email);
      if (!data.success) {
        showError(getErrorMsg(data.error, data.error === 'NOT_FOUND' ? 404 : 0));
        return;
      }
      renderConfirm(data.order);
    } catch (_) {
      showError(getErrorMsg('NETWORK'));
    } finally {
      setSubmitLoading(false);
    }
  }

  async function doCancel() {
    if (!pendingOrder || confirmBtn.disabled) return;

    const reason = (reasonEl?.value || '').trim();
    if (reason.length < REASON_MIN) {
      highlightError(reasonEl);
      announce(T.reasonRequired || 'Indica un motivo de al menos 20 caracteres.');
      return;
    }

    setConfirmLoading(true);
    try {
      const data = await apiCall('cancel', pendingOrder.orderName, pendingOrder.email);
      if (!data.success) {
        showError(getErrorMsg(data.error));
        return;
      }
      showSuccess(data.order);
    } catch (_) {
      showError(getErrorMsg('NETWORK'));
    } finally {
      setConfirmLoading(false);
    }
  }

  async function apiCall(action, orderName, email) {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ orderName, email, action }),
    });
    return res.json();
  }

  function renderConfirm(order) {
    currentItems = order.items || [];
    document.getElementById('oc-confirm-name').textContent = order.name;
    document.getElementById('oc-confirm-date').textContent = formatDate(order.createdAt);

    const remaining = order.eligibility?.remainingSeconds || 0;
    const countdownEl = document.getElementById('oc-countdown');
    if (countdownEl) {
      countdownEl.textContent = formatCountdown(remaining);
      countdownEl.style.display = remaining > 0 ? '' : 'none';
    }

    const listEl = document.getElementById('oc-items-list');
    listEl.innerHTML = currentItems.map(function (item, i) {
      const img = item.imageUrl
        ? '<img class="oc-item-img" src="' + escAttr(item.imageUrl) + '" alt="" loading="lazy">'
        : '<div class="oc-item-img oc-item-img--ph"></div>';
      const buyBtn = item.productUrl
        ? '<a href="' + escAttr(item.productUrl) + '" class="oc-btn oc-btn--black oc-btn--sm">' + esc(T.buyAgain || 'Volver a comprar') + '</a>'
        : (item.variantId
          ? '<button type="button" class="oc-btn oc-btn--black oc-btn--sm" data-buy-index="' + i + '">' + esc(T.buyAgain || 'Volver a comprar') + '</button>'
          : '');
      return (
        '<div class="oc-item-card">' + img +
        '<div class="oc-item-card-body">' +
        '<span class="oc-item-card-title">' + esc(item.title) + '</span>' +
        '<span class="oc-item-qty">× ' + esc(String(item.quantity)) + '</span>' +
        buyBtn +
        '</div></div>'
      );
    }).join('');

    listEl.querySelectorAll('[data-buy-index]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = parseInt(this.getAttribute('data-buy-index'), 10);
        addToCart(currentItems[idx]?.variantId, currentItems[idx]?.quantity || 1, this);
      });
    });

    if (reasonEl) reasonEl.value = '';
    updateReasonCounter();
    startCancelDelay();
    showConfirm();
    announce(T.retentionTitle || '¿Has cambiado de idea?');
  }

  function startCancelDelay() {
    delayReady = false;
    clearTimeout(delayTimer);
    clearInterval(delayInterval);
    updateCancelButtonState();

    let left = Math.ceil(CANCEL_DELAY / 1000);
    const hintTpl = T.delayHint || 'Podrás confirmar en __S__ s...';
    if (delayHintEl) delayHintEl.textContent = hintTpl.replace('__S__', String(left));

    delayInterval = setInterval(function () {
      left -= 1;
      if (delayHintEl) {
        delayHintEl.textContent = left > 0
          ? hintTpl.replace('__S__', String(left))
          : '';
      }
      if (left <= 0) {
        clearInterval(delayInterval);
        delayReady = true;
        updateCancelButtonState();
      }
    }, 1000);

    delayTimer = setTimeout(function () {
      delayReady = true;
      updateCancelButtonState();
    }, CANCEL_DELAY);
  }

  function updateReasonCounter() {
    if (!reasonCounterEl) return;
    const len = (reasonEl?.value || '').trim().length;
    const tpl = T.reasonCounter || '__N__ / __M__ mín.';
    reasonCounterEl.textContent = tpl.replace('__N__', String(len)).replace('__M__', String(REASON_MIN));
    reasonCounterEl.classList.toggle('oc-reason-counter--ok', len >= REASON_MIN);
    reasonCounterEl.classList.toggle('oc-reason-counter--warn', len > 0 && len < REASON_MIN);
  }

  function updateCancelButtonState() {
    if (!confirmBtn) return;
    const reasonOk = (reasonEl?.value || '').trim().length >= REASON_MIN;
    confirmBtn.disabled = !(delayReady && reasonOk);
  }

  function showSuccess(order) {
    hideAll();
    successEl.classList.add('oc-visible');

    const tpl = order.refunded
      ? (T.successMsgRefunded || T.successMsg || '')
      : (T.successMsgNoRefund || T.successMsg || '');
    const msgEl = document.getElementById('oc-success-msg');
    if (msgEl) msgEl.textContent = tpl.replace('__ORDER__', order.name || '');

    loadRecommendations(order.items || currentItems);
    successEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    announce(T.successHeadline || T.successTitle || 'Pedido cancelado');
  }

  async function loadRecommendations(items) {
    const grid = document.getElementById('oc-recommendations');
    if (!grid) return;

    const productId = (items || []).map(function (i) { return i.productId; }).find(Boolean);
    if (!productId) {
      grid.innerHTML = '';
      return;
    }

    grid.innerHTML = '<p class="oc-recs-loading">' + esc(T.recsTitle || '') + '…</p>';

    try {
      const res = await fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related');
      const data = await res.json();
      const products = data.products || [];
      if (!products.length) {
        grid.innerHTML = '';
        return;
      }

      grid.innerHTML = products.map(function (p) {
        const v = (p.variants || []).find(function (x) { return x.available; }) || p.variants?.[0];
        const price = p.price ? formatMoney(p.price) : '';
        const img = p.featured_image
          ? '<img src="' + escAttr(p.featured_image) + '" alt="' + escAttr(p.title) + '" loading="lazy">'
          : '';
        return (
          '<div class="oc-rec-card">' +
          '<a href="/products/' + escAttr(p.handle) + '" class="oc-rec-img">' + img + '</a>' +
          '<div class="oc-rec-body">' +
          '<a href="/products/' + escAttr(p.handle) + '" class="oc-rec-title">' + esc(p.title) + '</a>' +
          '<span class="oc-rec-price">' + esc(price) + '</span>' +
          (v ? '<button type="button" class="oc-btn oc-btn--black oc-btn--sm oc-rec-add" data-variant="' + v.id + '">' + esc(T.addToCart || 'Añadir al carrito') + '</button>' : '') +
          '</div></div>'
        );
      }).join('');

      grid.querySelectorAll('.oc-rec-add').forEach(function (btn) {
        btn.addEventListener('click', function () {
          addToCart(parseInt(this.getAttribute('data-variant'), 10), 1, this);
        });
      });
    } catch (_) {
      grid.innerHTML = '';
    }
  }

  async function addToCart(variantId, qty, btnEl) {
    if (!variantId) return;
    const orig = btnEl.textContent;
    btnEl.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 }),
      });
      if (res.ok) {
        btnEl.textContent = T.addedToCart || 'Añadido';
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') setTimeout(function () { drawer.open(); }, 400);
      } else {
        btnEl.disabled = false;
        btnEl.textContent = orig;
      }
    } catch (_) {
      btnEl.disabled = false;
      btnEl.textContent = orig;
    }
  }

  function showSkeleton() { hideAll(); skeletonEl.classList.add('oc-visible'); }
  function showConfirm() { hideAll(); confirmEl.classList.add('oc-visible'); confirmEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  function showError(msg) { hideAll(); errorEl.classList.add('oc-visible'); const el = document.getElementById('oc-error-msg'); if (el) el.textContent = msg; announce(msg); }
  function showForm() {
    hideAll();
    formSection.style.display = '';
    pendingOrder = null;
    clearInterval(delayInterval);
    inputOrder.focus();
  }
  function hideAll() {
    formSection.style.display = 'none';
    skeletonEl.classList.remove('oc-visible');
    confirmEl.classList.remove('oc-visible');
    successEl.classList.remove('oc-visible');
    errorEl.classList.remove('oc-visible');
  }

  function setSubmitLoading(loading) {
    submitBtn.disabled = loading;
    toggleSpinner('oc-submit-text', 'oc-submit-spinner', loading);
  }
  function setConfirmLoading(loading) {
    if (confirmBtn) confirmBtn.disabled = loading || !(delayReady && (reasonEl?.value || '').trim().length >= REASON_MIN);
    toggleSpinner('oc-confirm-text', 'oc-confirm-spinner', loading);
  }
  function toggleSpinner(textId, spinId, loading) {
    const t = document.getElementById(textId);
    const s = document.getElementById(spinId);
    if (t) t.style.display = loading ? 'none' : '';
    if (s) s.style.display = loading ? '' : 'none';
  }

  function normalizeOrderName(raw) {
    if (/^[A-Z]{1,3}\d+$/.test(raw)) return raw;
    if (/^\d+$/.test(raw) && ORDER_PREFIX) return ORDER_PREFIX + raw;
    return raw;
  }
  function isValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(e); }
  function formatDate(iso) {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleDateString(HTML_LANG, {
        day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit',
      });
    } catch (_) { return iso; }
  }
  function formatCountdown(seconds) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return (T.countdown || 'Quedan __H__h __M__min').replace('__H__', String(h)).replace('__M__', String(m));
  }
  function formatMoney(cents) {
    try {
      return (Number(cents) / 100).toLocaleString(HTML_LANG, {
        style: 'currency', currency: (window.Shopify?.currency?.active || 'EUR'),
      });
    } catch (_) { return String(cents); }
  }
  function highlightError(el) {
    if (!el) return;
    el.classList.add('oc-input--error');
    el.addEventListener('input', function () { this.classList.remove('oc-input--error'); }, { once: true });
  }
  function announce(msg) {
    if (liveRegion) { liveRegion.textContent = ''; liveRegion.textContent = msg; }
  }
  function getErrorMsg(code, status) {
    if (status === 429 || code === 'RATE_LIMIT') return ERRORS.RATE_LIMIT || 'Demasiados intentos.';
    if (code === 'NOT_FOUND') return ERRORS.NOT_FOUND || 'No encontramos el pedido.';
    if (code === 'WINDOW_EXPIRED') return ERRORS.WINDOW_EXPIRED || 'Han pasado más de 3 horas.';
    if (code === 'ALREADY_CANCELLED') return ERRORS.ALREADY_CANCELLED || 'Ya cancelado.';
    if (code === 'ALREADY_FULFILLED') return ERRORS.ALREADY_FULFILLED || 'Pedido en preparación.';
    if (code === 'REFUND_FAILED') return ERRORS.REFUND_FAILED || 'Error al reembolsar.';
    if (code === 'CANCEL_FAILED') return ERRORS.CANCEL_FAILED || 'No se pudo cancelar.';
    return ERRORS.NETWORK || 'Error de conexión.';
  }
  function esc(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function escAttr(s) { return String(s).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
})();
